import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"height":"100%","position":"relative"} }
const _hoisted_2 = {
  class: "table columns",
  style: {"gap":"4rem"}
}
const _hoisted_3 = {
  class: "col3 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_4 = {
  key: 0,
  class: "row-top"
}
const _hoisted_5 = { class: "pad-s" }
const _hoisted_6 = { class: "row-top" }
const _hoisted_7 = { class: "pad-s" }
const _hoisted_8 = { class: "row-top" }
const _hoisted_9 = { class: "pad-s" }
const _hoisted_10 = {
  class: "col2 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_11 = { class: "row-top" }
const _hoisted_12 = { class: "pad-s" }
const _hoisted_13 = {
  key: 0,
  class: "row-top"
}
const _hoisted_14 = { class: "pad-s" }
const _hoisted_15 = { class: "row-top" }
const _hoisted_16 = { class: "pad-s" }
const _hoisted_17 = {
  key: 0,
  class: "col3 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_18 = { class: "row-top" }
const _hoisted_19 = { class: "pad-s" }
const _hoisted_20 = {
  key: 0,
  class: "row-top"
}
const _hoisted_21 = { class: "pad-s" }
const _hoisted_22 = {
  key: 1,
  class: "row-top"
}
const _hoisted_23 = { class: "pad-s" }
const _hoisted_24 = {
  class: "col4 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_25 = { class: "row-top" }
const _hoisted_26 = {
  class: "table columns mtop-10",
  style: {"gap":"3.5rem"}
}
const _hoisted_27 = { class: "col gap-04" }
const _hoisted_28 = { class: "col gap-04" }
const _hoisted_29 = { class: "col gap-04" }

import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'
import { ref, computed, onMounted, nextTick } from 'vue'
import patientapi from "@/api/patientapi"
import { apiDate } from "@/api/apicommon"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'addEcosystem',
  props: {
  ecosystemAdded: {
    type: Function,
    required: false
  }
},
  setup(__props) {

const props = __props

const { t } = useI18n();
const appUserStore = useAppUserStore()

const dropd = ref(null)
const currentEntryStore = useCurrentEntryStore()
const focus = ref(null)

const contentText = ref("")

const patientAge = computed(() => {
  const entryDate = apiDate(currentEntryStore.currentEntryDate)
  const birthDate = apiDate(currentEntryStore.currentPatient.birthDate)
  const timeDifference = entryDate - birthDate
  const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
  return years
})

function startWithNewText(newTextPart1 = '', newTextPart2 = '') {
  let newText = ""
  let focusIndex
  if (newTextPart1) {
    if (!newTextPart1.endsWith(' ')) {newTextPart1 += ' '}
    if (newTextPart2 && !newTextPart2.startsWith(' ')) {newTextPart2 = ' ' + newTextPart2}
    focusIndex = newTextPart1.length
    newText = newTextPart1 + newTextPart2 + ' '
  }
  contentText.value = newText
  //Focus
  focus.value.innerRef.focus()
  if (newTextPart2) {
    nextTick(() => {
      focus.value.innerRef.setSelectionRange(focusIndex, focusIndex)
    })
  }
}

async function createFCT() {
  const entryId = currentEntryStore.currentEntryId;
  const textToSave = contentText.value.trim();
  if (!textToSave) return;
  contentText.value = "";
  
  await patientapi.addEcosystem(textToSave, entryId);

  if (props.ecosystemAdded) {
    props.ecosystemAdded();
  }

  currentEntryStore.reloadAfterHistoryChange();
}

function toInput(txt) {
  if (!contentText.value.endsWith(' ')) {contentText.value += ' '}
  contentText.value += txt + ' '
  focus.value.innerRef.focus()
}

function toInputAsDouble(suggestionPart1, suggestionPart2) {
  let existingText = contentText.value
  if (!existingText.endsWith(' ')) {existingText += ' '}
  if (!suggestionPart1.endsWith(' ')) {suggestionPart1 += ' '}
  if (!suggestionPart2.startsWith(' ')) {suggestionPart2 = ' ' + suggestionPart2}
  const focusIndex = existingText.length + suggestionPart1.length
  existingText += suggestionPart1 + suggestionPart2 + ' '
  //Update values
  contentText.value = existingText
  //Focus
  focus.value.innerRef.focus()
  nextTick(() => {
      focus.value.innerRef.setSelectionRange(focusIndex, focusIndex)
  })
}

onMounted(() => {
  focus.value.innerRef.focus()
})


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-modal w-maxC",
      style: {"position":"absolute","bottom":"0","right":"0","cursor":"auto"},
      onClick: _cache[38] || (_cache[38] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (patientAge.value > 16)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_svg_item, {
                    icon: "person",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.job'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.job')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.workTime'), _unref(t)('patient.addEcosystem.hoursPerWeek'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.workTimeLabel')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_svg_item, {
                icon: "people",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (patientAge.value >= 18)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.noPartner'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.noPartner')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value >= 18)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.inCouple'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.inCouple')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value < 20)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 2,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.parents'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.parents')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value >= 20)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 3,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.children'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.children')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.petsValue'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.pets')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.violence'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.violence')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_svg_item, {
                icon: "buildingHouse",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (patientAge.value > 65)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.autonomousAtHome'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.autonomousAtHome')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.livesOnFloor'), _unref(t)('patient.addEcosystem.floor'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.livesOnFloorLabel')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              (patientAge.value > 65)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.nursingHome'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.nursingHome')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value > 65)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 2,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.walkingAid'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.walkingAid')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value > 65)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 3,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.homeHelp'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.homeHelp')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_svg_item, {
                icon: "brain",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.sleepLatency'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.sleepLatency')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.nightWakings'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.nightWakings')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.averageSleepDuration'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.averageSleepDuration')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ])
          ]),
          (patientAge.value > 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_svg_item, {
                    icon: "heart",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.physicalActivity'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.physicalActivity')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_svg_item, {
                icon: "biochemical",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.drinks'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.drinks')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.diet'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addEcosystem.diet')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (patientAge.value > 12)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_svg_item, {
                    icon: "toxic",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.noSmoking'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.noSmoking')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.smoking'), _unref(t)('patient.addEcosystem.cigarettesPerDay'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addEcosystem.smokingLabel')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (patientAge.value > 15)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_svg_item, {
                        icon: "toxic",
                        styles: "main-m size-l"
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.noAlcohol'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.noAlcohol')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.alcohol'), _unref(t)('patient.addEcosystem.glassesPerWeek'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.alcoholLabel')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (patientAge.value > 15)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_svg_item, {
                        icon: "toxic",
                        styles: "main-m size-l"
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.noDrugs'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.noDrugs')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.cannabis'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.cannabis')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.cocaine'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.cocaine')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_button_group, {
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (startWithNewText(_unref(t)('patient.addEcosystem.opioids'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addEcosystem.opioids')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((dropd).value = $event)),
              openOn: "RbEcosystem"
            }, {
              dropd: _withCtx(() => [
                _createVNode(editAppUserPreferences, {
                  title: _unref(t)('patient.addEcosystem.favorites'),
                  referenceTextType: "RbEcosystem",
                  dtoKey: "rbEcosystem"
                }, null, 8, ["title"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_button_group, { class: "pad-s" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "star",
                      styles: "main-h size-l",
                      class: "txt-primary"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appUserStore).currentAppUserData?.preferences?.rbEcosystem.split('\n'), (suggestion, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  suggestion
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: ($event: any) => (startWithNewText(suggestion))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, { txt: suggestion }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "line-h mtop-10" }, null, -1)),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (toInput(_unref(t)('patient.addEcosystem.left'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.left')
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (toInput(_unref(t)('patient.addEcosystem.right'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.right')
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (toInput(_unref(t)('patient.addEcosystem.in'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.in') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[31] || (_cache[31] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addEcosystem.yearsAgo'), _unref(t)('patient.addEcosystem.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.yearsAgo') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addEcosystem.atAge'), _unref(t)('patient.addEcosystem.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.atAge') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (toInput(_unref(t)('patient.addEcosystem.since'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.since') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[34] || (_cache[34] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addEcosystem.sinceAge'), _unref(t)('patient.addEcosystem.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addEcosystem.sinceAge') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_inputComboBox2, {
        ref_key: "focus",
        ref: focus,
        class: "mtop-15",
        modelValue: contentText.value,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((contentText).value = $event)),
        onKeyup: _cache[37] || (_cache[37] = _withKeys(($event: any) => (createFCT()), ["enter"])),
        style: {"width":"100%"},
        hasDropd: false
      }, {
        post: _withCtx(() => [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "line-v" }, null, -1)),
          _createVNode(_component_buttonGroup, {
            theme: "inline",
            onClick: _cache[35] || (_cache[35] = ($event: any) => (createFCT()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "check",
                styles: "size-l"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})